import _ from "lodash";
import type React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useKYCContext } from "@/features/auth/hooks/use-kyc-context";
import { Themes } from "@/types/theme";
import { Button } from "@/atoms-react/button/Button.react.tsx";
import { useNavigate } from "react-router-dom";
import { KYCStatusType } from "@/features/kyc/types";

type IdentityDocumentsProps = { statusKyc: KYCStatusType } & React.ComponentPropsWithoutRef<"div">;

export const LevelOlkyAccountSilverOR = ({ statusKyc, ...props }: IdentityDocumentsProps) => {
  const { t } = useTranslation(["pass"]);
  const { status } = useKYCContext();
  const navigate = useNavigate();

  return (
    <div
      className={twMerge("flex flex-col justify-between md:ml-6 md:block md:pt-4 md:pb-6 2xl:ml-0")}
      {..._.omit(props, "className")}
    >
      <div className="flex w-full flex-col p-4">
        <Button
          size="md"
          theme={Themes.primary}
          disabled={
            status === KYCStatusType.AUTHENTICATED_GOLD ||
            (statusKyc === KYCStatusType.AUTHENTICATED_SILVER &&
              status === KYCStatusType.AUTHENTICATED_SILVER)
          }
          onClick={() => navigate("/pass/support")}
          iconPosition="before"
          className="mt-4 h-8 w-48 border-none text-white text-xs hover:bg-slate-50 sm:h-10 sm:w-64 sm:text-base lg:h-8 lg:w-72 lg:text-sm xl:h-10 xl:text-base xl:text-lg dark:bg-white dark:text-white dark:hover:bg-slate-50"
        >
          {t("olkypass.general.level_modal_documents.gold_form_button")}
        </Button>
      </div>
    </div>
  );
};
